import { render } from "./UploadManualView.vue?vue&type=template&id=417ea70c"
import script from "./UploadManualView.vue?vue&type=script&lang=js"
export * from "./UploadManualView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/git/index-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__